module.exports = __webpack_public_path__ + "img/logo-colored.c91ea53d.svg";